exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.img-inspeccion{width:100%}.vh--flex{display:-webkit-box}.vh--message-bottom{bottom:20px;left:20px}", ""]);

// exports
